import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import API_ENDPOINTS from '../api/apiConfig';
import Toast from '../components/Toast';
import useToast from '../hooks/useToast';
import HomeServices from './HomeServices';
import HomeChooseUs from './HomeChooseUs';
import RequestCall from './RequestCall';
import EmiCalculator from './EmiCalculator';
import JoinPartnerBanner from './JoinPartnerBanner';

function Home() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        amount: '',
        duration_months: '',
        loan_type: '',
    });
    const { toast, showToast, hideToast } = useToast();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.querySelectorAll('.set-bg').forEach(el => {
            const bg = el.getAttribute('data-setbg');
            if (bg) el.style.backgroundImage = `url('/${bg}')`;
        });
    }, []);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

   const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(API_ENDPOINTS.CREATELOANREQUEST, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            const data = await response.json();
            if (data.status) {
                showToast(data.message, 'success');       // ✅ success
                setFormData({ name: '', phone: '', amount: '', duration_months: '', loan_type: '' });
            } else {
                showToast(data.message, 'error');          // ❌ error
            }
        } catch (err) {
            showToast('Network error! Please try again.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const loanTypes = [
        { value: 'personal', label: 'Personal Loan' },
        { value: 'business', label: 'Business Loan' },
        { value: 'loan_against_property', label: 'Loan Against Property' },
        { value: 'credit_card', label: 'Credit Card' },
        { value: 'balance_transfer', label: 'Balance Transfer / Top-Up' },
        { value: 'gold', label: 'Gold Loan' },
        { value: 'car', label: 'Car Loan' },
        { value: 'home', label: 'Home Loan' },
        { value: 'insurance', label: 'Insurance' },
    ];

    return (
        <>
            {/* Toast Notification */}
            <Toast message={toast.message} type={toast.type} onClose={hideToast} />

            {/* Hero Section */}
            <section className="hero set-bg" data-setbg="img/main-ban.webp">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="hero__text">
                                <h2>Find The Best Loan For Your Needs</h2>
                                <p>Apply for a personal, business, or home loan in minutes — fast, easy, and secure.</p>
                                {/* <a href="#" className="primary-btn">Get Started</a>
                                <a href="#" className="primary-btn howit-btn">How It Works</a> */}
                            </div>
                        </div>
                        <div className="col-lg-5 offset-lg-2">
                            <div className="hero__form">
                                <h3>How much do you need?</h3>
                                <form onSubmit={handleSubmit}>
                                    <div className="input-list">
                                        <div className="input-list-item">
                                            <p>Amount of money (₹):</p>
                                            <input
                                                type="number"
                                                name="amount"
                                                value={formData.amount}
                                                onChange={handleChange}
                                                placeholder="e.g. 500000"
                                                required
                                            />
                                        </div>
                                        <div className="input-list-item">
                                            <p>How long for (months):</p>
                                            <input
                                                type="number"
                                                name="duration_months"
                                                value={formData.duration_months}
                                                onChange={handleChange}
                                                placeholder="e.g. 24"
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Redesigned Loan Type Dropdown */}
                                    <div className="input-full-width">
                                        <p>Loan Type:</p>
                                        <div style={{ position: 'relative' }}>
                                            <select
                                                name="loan_type"
                                                value={formData.loan_type}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    width: '100%',
                                                    padding: '12px 40px 12px 15px',
                                                    border: '2px solid #e0e0e0',
                                                    borderRadius: '8px',
                                                    fontSize: '15px',
                                                    fontWeight: '500',
                                                    color: formData.loan_type ? '#333' : '#999',
                                                    backgroundColor: '#fff',
                                                    appearance: 'none',
                                                    cursor: 'pointer',
                                                    outline: 'none',
                                                    transition: 'border-color 0.2s',
                                                }}
                                                onFocus={e => e.target.style.borderColor = '#7b5ea7'}
                                                onBlur={e => e.target.style.borderColor = '#e0e0e0'}
                                            >
                                                <option value="" disabled>Select a Loan Type</option>
                                                {loanTypes.map(lt => (
                                                    <option key={lt.value} value={lt.value}>{lt.label}</option>
                                                ))}
                                            </select>
                                            {/* Custom arrow icon */}
                                            <span style={{
                                                position: 'absolute',
                                                right: '14px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                pointerEvents: 'none',
                                                color: '#7b5ea7',
                                                fontSize: '18px',
                                            }}>▾</span>
                                        </div>
                                    </div>

                                    <div className="input-list last">
                                        <div className="input-list-item">
                                            <p>Name:</p>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                placeholder="Your full name"
                                                required
                                            />
                                        </div>
                                        <div className="input-list-item">
                                            <p>Phone:</p>
                                            <input
                                                type="tel"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                placeholder="10-digit number"
                                                maxLength={15}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <button
                                        type="submit"
                                        className="site-btn"
                                        disabled={loading}
                                        style={{ opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                                    >
                                        {loading ? 'Submitting...' : 'Get Your Loan Now!'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Hero Section End --> */}

            {/* <!-- Home About Begin --> */}
            <section className="home-about spad">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="home__about__text">
                                <div className="section-title">
                                    <h2>Thousands Of Customers Trust Our Financial Services</h2>
                                    <p>From personal loans to home loans and insurance, we offer tailored financial solutions to help you achieve your goals quickly and confidently.</p>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="home__about__item">
                                            <h4>Our Company</h4>
                                            <p>We are a trusted financial services provider offering a wide range of loan products and insurance solutions.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="home__about__item">
                                            <h4>Our Vision</h4>
                                            <p>To make financial assistance accessible, transparent, and stress-free for every individual and business.</p>
                                        </div>
                                    </div>
                                </div>
                                <Link to="/about" className="primary-btn">Learn More</Link>
                            </div>
                        </div>
                        <div className="col-lg-5 offset-lg-1">
                            <div className="home__about__img">
                                <img src="img/about/about.webp" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Home About End --> */}

            {/* <!-- Loan Services Section Begin --> */}
            <HomeServices />
            {/* <!-- Loan Services Section End --> */}

            {/* <!-- Choose Section Begin --> */}
            <HomeChooseUs />
            {/* <!-- Choose Section End --> */}

            {/* <!-- Call Section Begin --> */}
            <RequestCall />
            {/* <!-- Call Section End --> */}

             <EmiCalculator />
            
            {/* <!-- Blog Section Begin --> */}
            <section className="latest spad">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Latest Financial Tips & News</h2>
                                <p>Stay informed with the latest updates on loans, interest rates, and financial planning.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="latest__blog__item">
                                <h5><Link to="/blog">How To Choose The Right Loan For You</Link></h5>
                                <p>With so many loan options available, it can be confusing to pick the right one. Here's a simple guide to help you decide...</p>
                                <div className="latest__blog__author">
                                    <div className="latest__blog__author__pic">
                                        <img src="img/latest/lb-1.png" alt="" />
                                    </div>
                                    <div className="latest__blog__author__text">
                                        <h6>Financial Desk</h6>
                                        <span>10th January, 2025</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="latest__blog__item">
                                <h5><Link to="/blog">Top Benefits of Balance Transfer Loans</Link></h5>
                                <p>If you're paying high EMIs on an existing loan, a balance transfer could save you thousands of rupees in interest...</p>
                                <div className="latest__blog__author">
                                    <div className="latest__blog__author__pic">
                                        <img src="img/latest/lb-2.png" alt="" />
                                    </div>
                                    <div className="latest__blog__author__text">
                                        <h6>Financial Desk</h6>
                                        <span>18th February, 2025</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="latest__blog__item">
                                <h5><Link to="/blog">Why A Gold Loan Is The Smartest Option</Link></h5>
                                <p>Gold loans offer the fastest disbursal with the lowest documentation requirement. Find out why thousands prefer gold loans...</p>
                                <div className="latest__blog__author">
                                    <div className="latest__blog__author__pic">
                                        <img src="img/latest/lb-3.png" alt="" />
                                    </div>
                                    <div className="latest__blog__author__text">
                                        <h6>Financial Desk</h6>
                                        <span>5th March, 2025</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 text-center">
                            <Link to="/blog" className="primary-btn">View More</Link>
                        </div>
                    </div>
                </div>
                <JoinPartnerBanner />
            </section>
            {/* <!-- Blog Section End --> */}
        </>
    );
}

export default Home;